
<tps-assistant-message [role]="'assistant'" [messageContent]="message()">
  <div class="order-list">
    @for (order of orders(); track order.id) {
      <ngt-card
        status="info"
        [id]="order.id"
        [label]="order.name"
        [badgeLabel]="i18n.translate('manufacturing-order:' + order.status)()"
        badgeStatus="neutral"
        style="min-height: max-content"
      />
    }
  </div>
</tps-assistant-message>
